import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import SidebarIcons from "./SidebarIcons";
import SidebarShadow from "./SidebarShadow";
import Navbar from "./Navbar";

const MiniLayout = () => {
  const role = useSelector((store) => store.auth.employeeDetails?.role);
  const retailermenuItems = useSelector((state) => state.auth.retailermenuItems);
  const distributormenuItems = useSelector((state) => state.auth.distributormenuItems);
  const masterdistributorismenuItems = useSelector(
    (state) => state.auth.masterdistributorismenuItems
  );

  const [showContactPanel, setShowContactPanel] = useState(false);
  const navOpen = useSelector((s) => s.auth.nav);

  let menuItems;
  if (role === "DISTRIBUTOR") menuItems = distributormenuItems;
  else if (role === "MERCHANT" || role === "INDEPENDENT_MERCHANT") menuItems = retailermenuItems;
  else if (role === "MASTER_DISTRIBUTOR")
    menuItems = masterdistributorismenuItems;

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setShowContactPanel(false);
      }
    };

    if (showContactPanel) {
      document.addEventListener("keydown", handleKeyDown);
    }

    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [showContactPanel]);

return (
  <div className="flex flex-col min-h-screen bg-slate-50 overflow-x-clip overflow-y-visible">

    <Navbar />

    <div className="flex flex-1 pt-16">

      {/* ===== Sidebar (Desktop) ===== */}
      {navOpen && (
        <aside
          className="
            fixed
            h-[calc(100vh-2rem)] sm:h-[calc(100vh-4rem)]
            w-[240px] sm:w-[240px]
            bg-white
            border-r border-slate-200
            z-[100]
            transition-transform duration-300
          "
        >
          <SidebarShadow
            menuItems={menuItems}
            onItemClick={() => {}}
          />
        </aside>
      )}

      {/* ===== MAIN CONTENT ===== */}
      <main
        className={`
          flex-1
          pt-3 sm:pt-6
          px-3 sm:px-8
          transition-all duration-300
          min-w-0
          ${navOpen ? "sm:ml-[240px]" : "ml-0"}
        `}
      >
        <div className="w-full mx-auto">
          <Outlet />
        </div>
      </main>

    </div>
  </div>
);

};

export default MiniLayout;
